import { Component, Input, OnInit, OnDestroy, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterService } from 'lib/services/router.service';

type dropDownDataType = {
    listItems: any;
    dropdownMenuID: String;
};

@Component({
    selector: 'app-resource-center-header',
    templateUrl: './resource-center-header.component.html',
    styleUrls: ['./resource-center-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ResourceCenterHeaderComponent implements OnInit, OnDestroy {
    @Input() initialDropdownTitle: string;
    dropdownMenu: dropDownDataType = {
        listItems: [
            { title: 'Blog', href: '/blog' },
            { title: 'Case Studies', href: '/case-studies' },
            { title: 'Documents', href: '/documents' },
            { title: 'eBooks', href: '/eBooks' },
            { title: 'News and Events', href: '/News-Events' },
            {
                title: 'Reference Architecture',
                href: '/Reference-Architecture',
            },
            { title: 'Supported Software', href: '/Supported-Software' },
            { title: 'Whitepapers', href: '/Whitepapers' },
        ],
        dropdownMenuID: 'menu-id-resource-center',
    };
    constructor(
        private routerService: RouterService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    ngOnInit(): void {
        this.setDropdownMenuTitle();
        this.routerService.onRouteChange('resource-center-header', () => {
            this.setDropdownMenuTitle();
        });
    }
    /**
     * Purpose: On page load this function will run and determine the title that should be set for the resource header dropdown component
     * It extracts the first path of the url and looks in the list items array for a matching resource center location.
     * firstPath is first path of url
     * currentLocation is the index of the firstPath in the listItems array
     *
     */
    setDropdownMenuTitle(): void {
        if (!isPlatformBrowser(this.platformId)) {
            // Safe default for SSR - set default title when not in browser
            this.initialDropdownTitle = 'Categories';
            return;
        }

        try {
            const firstPath = this.routerService.url.parts[0];
            const currentLocation = this.dropdownMenu?.listItems?.findIndex((location) => location.href === `/${firstPath}`);
            this.initialDropdownTitle = this.dropdownMenu?.listItems[currentLocation]?.title;
            if (this.initialDropdownTitle === undefined) {
                this.initialDropdownTitle = 'Categories';
            }
        } catch (error) {
            // Fallback in case of any errors accessing location
            console.warn('Error accessing location in ResourceCenterHeaderComponent:', error);
            this.initialDropdownTitle = 'Categories';
        }
    }

    ngOnDestroy(): void {
        this.routerService.offRouteChange('resource-center-header');
    }
}
